import { render, staticRenderFns } from "./RfxResponseSubmissionDownloadList.vue?vue&type=template&id=618148b0"
import script from "./RfxResponseSubmissionDownloadList.vue?vue&type=script&lang=js"
export * from "./RfxResponseSubmissionDownloadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports